import { Component, Input } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import Utils from '../../../utils/utils';

import { TableBaseComponent } from '../table-base/table-base.component';

import { UserService } from '../../../../core/services/user.service';
import { UserContent } from '../../../models/user-content.model';
import { ConfigurationService } from '../../../services/configuration.service';

@Component({
  selector: 'app-user-content-table',
  templateUrl: './user-content-table.component.html'
})
export class UserContentTableComponent extends TableBaseComponent<UserContent> {

  @Input() detailLink = '/userContents';

  tableConfig: any = this.getTableConfig('userContent');

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected config: ConfigurationService,
    protected userService: UserService
  ) {
    super(router, route, config, userService);
  }

  getGlobalFilterFields() {
    this.globalFilters = this.globalFilters || [ {
      label: 'ID',
      field: 'id',
      active: this.showId
    }, {
      label: 'Name',
      field: 'name.value',
      active: true
    } ];

    return this.globalFilters
      .filter(filter => filter.active)
      .map(filter => filter.field);
  }

  // TODO remove when userContents module is fully implemented
  handleRowSelect(model: UserContent): void {
    if (this.isMultiSelection()) {
      Utils.addOrRemoveFromArray(this.selection, model);

    } else if (this.isSingleSelection()) {
      this.selectionChange.emit([model]);

    } else {
      this.goToDetailView(model);
    }
  }
}
